import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Container, Col, Row, Button} from "reactstrap";
import "../vodafone.css"
import iconTechnicianRed from "../media/icons/technician-red.png"
import iconTechnicianWhite from "../media/icons/technician-white.png"
import {parseKasBarcodeFromUrl} from "../api/common";

/**
 * Single Button
 */
class SingleButton extends React.Component {

    /**
     * Constructor
     * @param props
     */
    constructor(props){
        super(props);
    }

    /**
     * render
     * @returns {*}
     */
    render() {

        // button-class
        let buttonClass = "button-red";
        if(this.props.buttonStyleIsWhite){
            buttonClass = "button-white";
        }

        // disabled
        let disabled = false;
        if(this.props.buttonIsDisabled){
            disabled = true;
        }

        // return
        return <Row>
            <Col xs={12}>
                <Button className={buttonClass + " width-100"}
                        style={{height:"48px"}}
                        disabled={disabled}
                        onClick={this.props.buttonOnClick}>
                    {i18n.t(this.props.buttonTextResource, this.props)}
                </Button>
            </Col>
        </Row>;
    }
}

export default translate("translations")(SingleButton);